import {Subject} from "rxjs";
import {PlaybackControlEventTypes} from "./PlaybackControlEventTypes";
import {logger} from "../../log/logger";

const playbackControlEventSubject = new Subject<PlaybackControlEventTypes>();

export function subscribeToPlaybackControlEvents(callback: (message: PlaybackControlEventTypes) => void){
  const protectedCallback = (message: PlaybackControlEventTypes) => {
    try{
      callback(message);
    }catch(e){
      logger.lesson.error({message: `error encountered in observer of PlaybackControlEventTypes `, error: e as Error});
    }
  };
  const subscription = playbackControlEventSubject.subscribe(protectedCallback);
  return subscription.unsubscribe.bind(subscription);
}

function putEventOnBus(message: PlaybackControlEventTypes){
  playbackControlEventSubject.next(message);
}

export function emitPlayRequested(){
  putEventOnBus({type: "playRequested"});
}
